<template>
<svg class="cnm-icon" width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect y="0.866699" width="24" height="24" rx="12" fill="black" fill-opacity="0.5"/>
<path d="M16 8.8667L8 16.8667" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M8 8.8667L16 16.8667" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</template>